module.exports = __webpack_public_path__ + "static/media/team-meeting.31ed210f.svg";